import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import * as Highcharts from 'highcharts';
import {Options} from 'highcharts';
import moment from 'moment-timezone';
import {InsightsService} from "../../services/insights/insights.service";
import {AlertBannerService, AlertType} from "../../lib/alert-banner";
import {TrendChartService} from "../../services/trend-chart/trend-chart.service";

@Component({
  selector: 'app-pulse-nps-trend',
  templateUrl: './pulse-nps-trend.component.pug',
  styleUrls: ['./pulse-nps-trend.component.scss'],
  standalone: false
})
export class PulseNpsTrendComponent implements OnInit, OnChanges {

  @Input() start!: any;
  @Input() end!: any;
  @Input() request: any;
  @Input() survey: any;
  @Input() department: any;
  @Input() filterBy!: any;
  @Input() pause_load = false;
  @Output() dataLoaded = new EventEmitter<void>();
  updateFlag = false;
  data: any;

  Highcharts: typeof Highcharts = Highcharts;
  title: Highcharts.TitleOptions = {
    text: `-`,
    align: 'left',
    style: {"fontFamily": "TT Commons", fontWeight: 'normal', fontSize: "18px"}
  }

  subtitle: Highcharts.SubtitleOptions = {
    text: $localize`Displaying 0 requests`,
    align: 'left',
    style: {"fontFamily": "TT Commons"}
  }

  tooltip: Highcharts.TooltipOptions = {
    enabled: true,
    backgroundColor: 'white',
    borderWidth: '0',
    padding: 12,
    distance: 16,
    borderRadius: 4,
    shadow: true,
    useHTML: true,
    outside: true,
    formatter: function() {
      return `
      <div class='participation-tooltip' style="width:140px">

        <span class='tooltip-heading'>${moment.unix(this.x as number / 1000).format("[Q]Q, YYYY")}</span>
        <div class='tooltip-point'>
          <div class='tooltip-row'><b style='color:#32735F'>${this.point.custom.completed}</b> Completed</div>
          <div class='tooltip-row'><b style='color:#000000'>${this.point.custom.stopped}</b> Stopped</div>
        </div>
      </div>
      `
    },
    style: {
      fontFamily: 'TT Commons',
      fontWeight: '500',
      fontSize: '14px',
      padding: '0px',
      width: 135
    }
  }

  legend: Highcharts.LegendOptions = {
    enabled: false,
  }

  series: any = [
    {
      type: "column",
      pointWidth: 12,
      borderRadiusTopLeft: 2,
      borderRadiusTopRight: 2,
    }
  ]

  chartOptions: Options = TrendChartService.getOptions(
    [], -100, 100, 300, 800, '#FFF', 'rgb(50,115,95)', 'rgb(255, 255, 255)', ['#32735F', '#EAF1EF'], 'months', this.title, this.subtitle, this.tooltip, this.legend, this.series, true);

  constructor(private insightsService: InsightsService,
              private alertList: AlertBannerService) {}

  ngOnInit(): void {
    this.tooltip.outside = false;
  }

  get totalRequests() { return this.data.reduce((a, b) => { return a + b.completed + b.stopped }, 0)}

  private loadAndSetData() {
    if (this.pause_load) {
      this.emitDataLoaded();
      return;
    }

    this.insightsService.getPulseNPSTrend(this.start, this.end, this.request, this.department, this.survey).subscribe(data => {
      this.data = data;
      let series: any = [];
      for (let d of data) {
        series.push({ x: moment.utc(d['date'], 'YYYY_Q').toDate().getTime(), y: d['nps'],
        className: d['in_progress'] > 0 ? 'in-progress' : '',
        custom: {
          completed: d['completed'] ? d['completed'] : 0,
          stopped: d['stopped'] ? d['stopped'] : 0
      }});
      }
      this.chartOptions.title = {text: `${moment(this.start).format('[Q]Q, YYYY')} - ${moment(this.end).format('[Q]Q, YYYY')}`};
      let requestCount = this.totalRequests;
      if (requestCount === 1) {
        this.chartOptions.subtitle = {text: $localize`Displaying ${requestCount} request`};
      } else {
        this.chartOptions.subtitle = {text: $localize`Displaying ${requestCount} requests`};
      }
      TrendChartService.setChartOptionsFromData(this.chartOptions, series, 'quarters');
      this.updateFlag = true;
      this.emitDataLoaded();
    }, error => {
      console.log(error);
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
      TrendChartService.setChartOptionsFromData(this.chartOptions, [], 'quarters');
      this.updateFlag = true;
      this.emitDataLoaded();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadAndSetData();
  }

  private emitDataLoaded(): void {
    this.dataLoaded.emit();
  }
}
